import { render, staticRenderFns } from "./Sockets.vue?vue&type=template&id=1d29c60a&scoped=true"
import script from "./Sockets.vue?vue&type=script&lang=js"
export * from "./Sockets.vue?vue&type=script&lang=js"
import style0 from "./Sockets.vue?vue&type=style&index=0&id=1d29c60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d29c60a",
  null
  
)

export default component.exports